import React from "react";
import { createRoot } from "react-dom/client";
import maplibregl from "maplibre-gl";
import "@fontsource/space-grotesk/400.css";
import "@fontsource/space-grotesk/500.css";
import "@fontsource/space-grotesk/700.css";
import "./index.css";
import App from "./App";
import { IDIOMA, txt } from "./i18n";

// El index.html va en castellano; con el idioma ya resuelto se corrigen el
// titulo de la pestana y el atributo lang, que los lectores de pantalla usan
// para elegir la pronunciacion.
document.documentElement.lang = IDIOMA;
document.title = txt("app.titulo");

// El build de produccion de CRA (babel y terser sobre node_modules) corrompe
// el worker que maplibre-gl empaqueta como blob: ReferenceError en el worker
// y tiles del basemap sin parsear (mapa negro). En produccion se usa el
// worker CSP precompilado, que el script prebuild copia a public/ (webpack
// copia public/ verbatim, sin transformar). En desarrollo el worker blob
// funciona bien y no hace falta.
if (process.env.NODE_ENV === "production") {
  maplibregl.workerUrl = `${process.env.PUBLIC_URL}/maplibre-gl-csp-worker.js`;
}

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
